import axiosHttp from "./interceptor.service";

const uploadAppFile = (data) => {
    return axiosHttp.post("/lmt/uploadAppFile", data);
};

const getLatestAppFiles = () => {
    return axiosHttp.get("/lmt/getLatestAppFiles");
};

const getAllAppFiles = () => {
    return axiosHttp.get("/lmt/getAllAppFiles");
};

const deleteAppFile = (id) => {
    return axiosHttp.delete(`/lmt/deleteAppFile/${id}`);
};

const getAllVersionsByPlatform = (platform) => {
    return axiosHttp.get(`/lmt/getAllVersionsByPlatform/${platform}`);
};

export { uploadAppFile, getLatestAppFiles, getAllAppFiles, deleteAppFile, getAllVersionsByPlatform };
